import { getDomain } from '~/services/auth'
import API_URLS from '~/core/api-urls'
import {
  APP_NAMES,
  COOKIES_POLICY_URL,
  JAAS_TERMS_AND_CONDITIONS,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY_URL
} from '~/core/constants'
import { getOperatingSystem, OS } from '~/core/os'
import { translate } from '~/core/translate'

const SOURCES = {
  MEET: 'VideoMeetings'
}

const { origin, pathname, search } = window.location
const queryParams = new URLSearchParams(search)

const state = queryParams.get('state')
const token = queryParams.get('token')
const isVpaaS = queryParams.get('isVpaaS')
const clientId = queryParams.get('clientId')
const source = queryParams.get('source')
const _ga = queryParams.get('_ga')

const getStripeQueryParams = isSuccess => {
  const searchParams = new URLSearchParams()

  if (isSuccess) {
    searchParams.set('success', 'true')
  } else {
    searchParams.set('cancel', 'true')
  }

  if (isVpaaS) {
    searchParams.set('isVpaaS', 'true')
  }

  if (state) {
    searchParams.set('state', state)
  }

  if (token) {
    searchParams.set('token', token)
  }

  if (_ga) {
    searchParams.set('_ga', _ga)
  }

  return searchParams
}

const continueToApp = location => {
  if (state && isVpaaS) {
    window.location = `https://${getDomain()}/continue?state=${state}&isPaymentRedirect=true&is_vpaas=true`
  } else {
    window.location = location
  }
}

const logoutUrl = returnTo =>
  `https://${getDomain()}/v2/logout?returnTo=${returnTo}&client_id=${clientId}`

const isAuth0Redirect = Boolean(state) && Boolean(token)

const getMeetReturnTo = () => {
  const os = getOperatingSystem()
  if (os === OS.ANDROID && source === SOURCES.MEET) {
    return `${API_URLS.ANDROID_CALLBACK_URL}?error=Cancel`
  }

  return `${origin}/`
}

const vpaas = {
  isAuth0Redirect,
  name: APP_NAMES.VPAAS,
  documentTitle: 'Jitsi as a Service',
  getAuthRedirectUrl: () => `${API_URLS.JAAS}#/apikeys`,
  favIconUrl: 'https://vo-cdn.8x8.vc/static/jaas-logo.ico',
  stripeSuccessUrl: `${origin}${pathname}?${getStripeQueryParams(true)}`,
  stripeCancelUrl: `${origin}${pathname}?${getStripeQueryParams()}`,
  goToApp: () => continueToApp(`${API_URLS.JAAS}#/apikeys`),
  getLogoutUrl: () => logoutUrl(API_URLS.JAAS),
  getRedirectOnProSubscription: () => `${API_URLS.JAAS}#/apikeys`,
  getStripeProductUrl: () => `${API_URLS.PRODUCTS}?context=VPAAS`,
  cookiesPolicyUrl: COOKIES_POLICY_URL,
  privacyPolicyUrl: PRIVACY_POLICY_URL,
  termsAndConditionsUrl: JAAS_TERMS_AND_CONDITIONS,
  fullAppName: () => translate('eght_meet_api')
}

const meet = {
  isAuth0Redirect,
  name: APP_NAMES.MEET,
  documentTitle: 'Upgrade to 8x8 Meet Pro',
  getAuthRedirectUrl: () => `${origin}${pathname}`,
  favIconUrl: 'https://vo-cdn.8x8.vc/static/favicon.ico',
  stripeSuccessUrl: `${origin}${pathname}?${getStripeQueryParams(true)}`,
  stripeCancelUrl: `${origin}${pathname}?${getStripeQueryParams()}`,
  goToApp: () => continueToApp(`${origin}/`),
  getLogoutUrl: () => logoutUrl(getMeetReturnTo()),
  getRedirectOnProSubscription: () => `${origin}/`,
  getStripeProductUrl: () => API_URLS.PRODUCTS,
  cookiesPolicyUrl: COOKIES_POLICY_URL,
  privacyPolicyUrl: PRIVACY_POLICY_URL,
  termsAndConditionsUrl: TERMS_AND_CONDITIONS,
  fullAppName: () => translate('legal_footer_text')
}

export default {
  get current () {
    return isVpaaS ? vpaas : meet
  }
}
